// extracted by mini-css-extract-plugin
export default {"extend_open":"fqpVq5Sdh32JHGf60gjv","extendOpen":"fqpVq5Sdh32JHGf60gjv","extend_closed":"i2ehzlIzT24OVs6HCXnX","extendClosed":"i2ehzlIzT24OVs6HCXnX"};